import React from "react";
import ChooseRole from "./ChooseRole";
import Footer from "./Footer";
import Hero from "./Hero";
import Navbar from "./Navbar";

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <ChooseRole />
      <Footer />
    </div>
  );
};

export default HomePage;
